import { Model } from '@vuex-orm/core'
import Task from './Task'

export default class Client extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'clients'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      id: this.attr(null),
      name: this.attr(''),
      tasks: this.hasMany(Task, 'client_id'),
    }
  }
}